<template>
    <div class="ah-page loan-add-page">
        <div class="page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1 v-if="!loanSno">新增借款合約</h1>
                        <h1 v-else>編輯借款合約</h1>
                    </div>
                </div>
            </div>
        </div>
        <el-form ref="form" :model="form" :rules="rules" label-position="top" label-width="190px" v-loading="isLoading">
            <div>
                <div class="ah-container">
                    <div class="ah-block" style="margin-top: 25px">
                        <div class="block-title">借款合約</div>
                        <el-form-item prop="title" label="借款簡稱">
                            <el-input v-model="form.title" placeholder="例：2023 中國信託 紓困貸款" style="max-width: 650px" :maxlength="50" show-word-limit />
                        </el-form-item>
                        <div class="v-stack grow-last">
                            <el-form-item prop="approvalDate" label="核准日期">
                                <el-date-picker v-model="form.approvalDate" value-format="timestamp" type="date" placeholder="選擇日期"> </el-date-picker>
                            </el-form-item>
                            <el-form-item prop="totalAmount" label="總額度">
                                <money-input v-model="form.totalAmount" style="" @change="onAutoFillAmt" />
                            </el-form-item>
                        </div>
                        <el-form-item prop="note" label="說明">
                            <el-input v-model="form.note" type="textarea" :rows="4" :maxlength="200" show-word-limit />
                        </el-form-item>
                    </div>
                </div>
            </div>
            <div class="ah-container" style="margin-top: 35px">
                <el-row :gutter="25">
                    <el-col :sm="12">
                        <div class="ah-block">
                            <div class="block-title">
                                <el-checkbox v-model="isAmortization" @change="onRepaymentChange('isAmortization')">
                                    <span class="checkbox-as-title">按月平均攤還</span>
                                </el-checkbox>
                            </div>
                            <el-form-item prop="amortizationAmount" :rules="isAmortization ? rules.amortizationAmount : []" label="攤還額度借款金額">
                                <money-input v-model="form.amortizationAmount" :disabled="!isAmortization || repaymentWay !== 3" />
                            </el-form-item>
                            <el-form-item prop="amortizationRate" :rules="isAmortization ? rules.amortizationRate : []" label="貸款利率">
                                <money-input v-model="form.amortizationRate" :disabled="!isAmortization" :precision="3" style="width: 110px" suffix="%" />
                            </el-form-item>
                            <el-form-item prop="amortizationPeriods" :rules="isAmortization ? rules.amortizationPeriods : []" label="還款期限">
                                <div class="flex-block">
                                    <money-input v-model="form.amortizationPeriods" :disabled="!isAmortization" style="width: 110px" @change="onChangeAmortizationStartDate" suffix="期" />
                                    <span v-if="amortizationPeriodsYear !== '-'" class="suffix" style="color: #888"> （{{ amortizationPeriodsYear }} 年） </span>
                                </div>
                            </el-form-item>
                            <el-form-item prop="amortizationStartDate" :rules="isAmortization ? rules.amortizationStartDate : []" label="合約起訖日">
                                <div class="flex-block">
                                    <el-date-picker
                                        v-model="form.amortizationStartDate"
                                        :disabled="!isAmortization"
                                        value-format="timestamp"
                                        type="date"
                                        placeholder="選擇日期"
                                        :picker-options="{ disabledDate }"
                                        @change="onChangeAmortizationStartDate"
                                    >
                                    </el-date-picker>
                                    <span style="padding: 0 15px">至</span>
                                    <el-date-picker v-model="form.amortizationEndDate" disabled value-format="timestamp" type="date"> </el-date-picker>
                                </div>
                            </el-form-item>
                            <el-form-item prop="amortizationFixedPaymentDate" :rules="isAmortization ? rules.amortizationFixedPaymentDate : []" label="固定繳款日">
                                <div>
                                    <el-select v-model="form.amortizationFixedPaymentDate" :clearable="false" placeholder="請選擇">
                                        <el-option v-for="item in dateOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                                    </el-select>
                                </div>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :sm="12">
                        <div class="ah-block">
                            <div class="block-title">
                                <el-checkbox v-model="isRepayment" @change="onRepaymentChange('isRepayment')">
                                    <span class="checkbox-as-title">循環額度使用，期限內一次還本</span>
                                </el-checkbox>
                            </div>
                            <el-form-item prop="repaymentAmount" label="循環額度借款金額" :rules="isRepayment ? rules.repaymentAmount : []">
                                <money-input v-model="form.repaymentAmount" :disabled="!isRepayment || repaymentWay !== 3" />
                            </el-form-item>
                            <el-form-item prop="repaymentRate" label="貸款利率" :rules="isRepayment ? rules.repaymentRate : []">
                                <div class="flex-block">
                                    <money-input v-model="form.repaymentRate" :disabled="!isRepayment" :precision="3" style="width: 110px" suffix="%" />
                                </div>
                            </el-form-item>
                            <el-form-item prop="repaymentPeriods" label="還款期限天數" :rules="isRepayment ? rules.repaymentPeriods : []">
                                <div class="flex-block">
                                    <money-input v-model="form.repaymentPeriods" :disabled="!isRepayment" style="width: 110px" suffix="天" />
                                </div>
                            </el-form-item>
                            <el-form-item prop="repaymentEndDate" label="借款額度到期日" :rules="isRepayment ? rules.repaymentEndDate : []">
                                <el-date-picker v-model="form.repaymentEndDate" :disabled="!isRepayment" value-format="timestamp" type="date" placeholder="選擇日期" :picker-options="{ disabledDate }">
                                </el-date-picker>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <div style="margin: 25px 0; text-align: right">
                    <el-tooltip v-if="!isQR()" class="item" effect="dark" content="已有動撥紀錄，無法刪除" placement="top" :manual="form.drawdownCount <= 0">
                        <span style="margin-right: 10px;">
                            <el-button v-if="loanSno" type="danger" :loading="isLoading" :disabled="form.drawdownCount > 0" @click="onDelete" icon="el-icon-delete">
                                刪除
                            </el-button>
                        </span>
                    </el-tooltip>
                    <el-button :loading="isLoading" @click="$router.go(-1)" icon="el-icon-close">取消</el-button>
                    <el-button v-if="!isQR()" type="primary" class="primary-action" :loading="isLoading" @click="onSubmit" icon="el-icon-check">
                        <span v-if="loanSno">儲存</span>
                        <span v-else>新增</span>
                    </el-button>
                </div>
                <div v-if="loanSno" class="data-record">
                    <div>
                        <div v-if="creatorInfo" class="creator">資料建立：{{ creatorInfo }}</div>
                        <div v-if="editorInfo" class="editor">最後編輯：{{ editorInfo }}</div>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    data() {
        const nonZeroValidator = (rule, value, callback) => {
            if (value <= 0) callback(new Error('請輸入統一編號。'));
            callback();
        };

        return {
            isLoading: false,
            isAmortization: true,
            isRepayment: true,
            form: {
                sno: undefined,
                title: null,
                totalAmount: null,
                approvalDate: null,
                note: null,

                amortizationAlreadyPaidAmount: null,
                amortizationAlreadyPaidDate: null,
                amortizationAmount: null,
                amortizationRate: null,
                amortizationPeriods: null,
                amortizationStartDate: null,
                amortizationEndDate: null,
                amortizationFixedPaymentDate: null,

                repaymentAmount: null,
                repaymentRate: null,
                repaymentPeriods: null,
                repaymentEndDate: null,
            },
            rules: {
                title: [{ required: true, message: '此欄位為必填' }],
                totalAmount: [
                    {
                        required: true,
                        validator: nonZeroValidator,
                        message: '總額度不可為0',
                    },
                ],
                approvalDate: [{ required: true, message: '此欄位為必填' }],

                amortizationAlreadyPaidAmount: [
                    {
                        required: true,
                        validator: nonZeroValidator,
                        message: '總額度不可為0',
                        trigger: 'blur',
                    },
                ],
                amortizationAlreadyPaidDate: [{ required: true, message: '此欄位為必填', trigger: 'blur' }],
                amortizationAmount: [
                    {
                        required: true,
                        validator: nonZeroValidator,
                        message: '攤還額度借款金額不可為0',
                    },
                ],
                amortizationRate: [
                    {
                        required: true,
                    },
                ],
                amortizationPeriods: [
                    {
                        required: true,
                        validator: nonZeroValidator,
                        message: '還款期限不可為0',
                    },
                ],
                amortizationStartDate: [{ required: true, message: '此欄位為必填' }],
                amortizationEndDate: [{ required: true, message: '此欄位為必填' }],
                amortizationFixedPaymentDate: [
                    {
                        required: true,
                        validator: nonZeroValidator,
                        message: '固定繳款日期不可為0',
                    },
                ],

                repaymentAmount: [
                    {
                        required: true,
                        validator: nonZeroValidator,
                        message: '循環額度借款金額不可為0',
                    },
                ],
                repaymentRate: [
                    {
                        required: true,
                        validator: nonZeroValidator,
                        message: '貸款利率不可為0',
                    },
                ],
                repaymentPeriods: [
                    {
                        required: true,
                        validator: nonZeroValidator,
                        message: '還款期限天數不可為0',
                    },
                ],
                repaymentEndDate: [{ required: true, message: '此欄位為必填' }],
            },

            creator: null,
            createDate: null,
            editor: null,
            editDate: null,
        };
    },
    computed: {
        loanSno() {
            return this.$route.params.sno;
        },
        incomeItemName() {
            return this.form.title && `財務收入 / 還借款本金 / ${this.form.title}`;
        },
        payoutItemName() {
            return this.form.title && `財務收入 / 還借款本金 / ${this.form.title}`;
        },

        creatorInfo() {
            if (!this.form.crT_NAM || !this.form.crT_DAT) return false;

            return `${this.form.crT_NAM || '--'}, ${moment(this.form.crT_DAT).format('YYYY-MM-DD') || '--'}`;
        },
        editorInfo() {
            if (!this.form.upD_NAM || !this.form.upD_DAT) return false;

            return `${this.form.upD_NAM || '--'}, ${moment(this.form.upD_DAT).format('YYYY-MM-DD') || '--'}`;
        },
        repaymentWay() {
            if (this.isAmortization && this.isRepayment) return 3;
            if (this.isAmortization) return 2;
            return 1;
        },
        amortizationPeriodsYear() {
            return this.form.amortizationPeriods ? Math.round((this.form.amortizationPeriods / 12) * 100) / 100 : '-';
        },
        dateOptions() {
            const dates = [];
            for (let i = 1; i <= 31; i++) {
                dates.push({
                    value: i,
                    label: `每月 ${i} 日`,
                });
            }
            return dates;
        },
    },
    mounted() {
        if (this.loanSno) this.fetchData();
    },
    methods: {
        async fetchData() {
            try {
                this.isLoading = true;
                const resp = await this.$api({
                    method: 'GET',
                    url: 'LoanReceipt/GetLoanReceiptDetail',
                    params: { sno: this.loanSno },
                });
                this.form = resp.data.detail;

                // fetch還款類型勾選
                if (this.form.repaymentWay === 1) {
                    this.isAmortization = false;
                    this.form.amortizationAmount = null;
                    this.form.amortizationRate = null;
                    this.form.amortizationPeriods = 0;
                    this.form.amortizationStartDate = null;
                    this.form.amortizationEndDate = null;
                    this.form.amortizationFixedPaymentDate = null;
                } else if (this.form.repaymentWay === 2) {
                    this.isRepayment = false;
                    this.form.repaymentAmount = null;
                    this.form.repaymentRate = null;
                    this.form.repaymentPeriods = null;
                    this.form.repaymentEndDate = null;
                }
            } finally {
                this.isLoading = false;
            }
        },
        onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    try {
                        this.isLoading = true;

                        if (this.form.amortizationAlreadyPaidAmount === 0) {
                            this.form.amortizationAlreadyPaidAmount = null;
                        }

                        if (this.loanSno) await this.onUpdate();
                        else await this.onCreate();

                        await this.$store.dispatch('statement/updateStatementOptions');
                    } finally {
                        this.isLoading = false;
                    }
                }
            });
        },
        async onCreate() {
            await this.$api({
                method: 'POST',
                url: 'LoanReceipt/AddLoanReceipt',
                data: { ...this.getPayload(), repaymentWay: this.repaymentWay },
            });
            this.$message({
                showClose: true,
                message: '已成功建立借款',
                type: 'success',
            });

            this.onGoToList();
        },
        async onUpdate() {
            await this.$api({
                method: 'POST',
                url: 'LoanReceipt/UpdateLoanReceipt',
                data: { ...this.getPayload(), repaymentWay: this.repaymentWay },
            });
            this.$message({
                showClose: true,
                message: '已成功更新借款',
                type: 'success',
            });

            this.onGoToDetail();
        },
        onGoToList() {
            this.$router.push({ name: 'loan-management' });
        },
        onGoToDetail() {
            this.$router.push({ name: 'loan-management-detail' });
        },
        async onDelete() {
            try {
                await this.$confirm('確定要刪除此借款？如有動撥或還款紀錄，將一併被刪除。', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                this.isLoading = true;
                await this.$api({
                    method: 'POST',
                    url: 'LoanReceipt/DeleteLoanReceipt',
                    data: { sno: this.loanSno },
                });

                await this.$store.dispatch('statement/updateStatementOptions');

                this.$message({
                    showClose: true,
                    message: '已成功刪除借款',
                    type: 'success',
                });

                this.onGoToList();
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },

        onChangeAmortizationStartDate() {
            if (!this.form.amortizationStartDate) return;
            const END_DATE = moment(this.form.amortizationStartDate)
                .add(this.form.amortizationPeriods, 'month')
                .format('x');
            this.form.amortizationEndDate = Number(END_DATE);
        },
        getPayload() {
            if (this.repaymentWay === 1) {
                return {
                    ...this.form,
                    amortizationAmount: null,
                    amortizationRate: null,
                    amortizationPeriods: 0,
                    amortizationStartDate: null,
                    amortizationEndDate: null,
                    amortizationFixedPaymentDate: null,
                };
            }
            if (this.repaymentWay === 2) {
                return {
                    ...this.form,
                    repaymentAmount: null,
                    repaymentRate: null,
                    repaymentPeriods: null,
                    repaymentEndDate: null,
                };
            }
            return this.form;
        },
        onRepaymentChange(source) {
            this.$refs.form.clearValidate();

            // 當勾選皆被取消時，反向選取
            if (!this.isAmortization && !this.isRepayment) {
                if (source === 'isAmortization') {
                    this.$refs.form.clearValidate();
                    this.isRepayment = true;
                } else this.isAmortization = true;
            }

            // 當只有一種還款方式，自動帶入額度
            this.onAutoFillAmt();
        },
        onAutoFillAmt() {
            if (this.isAmortization && !this.isRepayment) {
                this.form.amortizationAmount = this.form.totalAmount;
            }
            if (!this.isAmortization && this.isRepayment) {
                this.form.repaymentAmount = this.form.totalAmount;
            }
        },
        disabledDate(date) {
            return this.form.approvalDate ? moment(date).isBefore(this.form.approvalDate) : true;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";

.loan-add-page {
    .checkbox-as-title {
        font-size: 12.5pt;
        font-weight: bold;
        padding-left: 5px;
    }

    .v-stack {
        display: flex;
        flex-direction: row;
        gap: 20px 20px;

        &.grow-last {
            > *:last-child {
                flex-grow: 1;
            }
        }
        &.grow-first {
            > *:first-child {
                flex-grow: 1;
            }
        }
    }

    .header {
        color: $main-color;
        border-top: 1px solid $main-color;
        padding-top: 10px;
        margin-bottom: 20px;
        font-size: 10pt;
    }
    .flex-block {
        display: flex;
    }
    .suffix {
        margin-left: 10px;
    }
    .prefix {
        margin-right: 10px;
    }

    .data-record {
        margin-top: 50px;
        padding-top: 10px;
        border-top: 1px solid #ddd;
        font-size: 10pt;
        text-align: right;
        color: #888;

        > div {
            display: inline-block;
            text-align: left;
        }
    }
    .button-set {
        display: flex;
        justify-content: center;
        margin-top: 40px;
    }
}
</style>
